import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { BranchType } from "../../types/branch";

export interface SettingsState {
  isImgModalOpen: string | null;
  branches: BranchType[];
  selectedBranch: BranchType | null;
  isBranchModalOpen: boolean;
  branchesLoaded: boolean;
}

const initialState: SettingsState = {
  isImgModalOpen: null,
  branches: [],
  selectedBranch: null,
  isBranchModalOpen: false,
  branchesLoaded: false,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    updateIsImgModalOpen: (state, action: PayloadAction<string | null>) => {
      state.isImgModalOpen = action.payload;
    },
    setSelectedBranch: (state, action: PayloadAction<BranchType>) => {
      state.selectedBranch = action.payload;
      localStorage.setItem("selectedBranch", String(action.payload.id));
      state.isBranchModalOpen = false;
    },
    setBranchesFromResponse: (state, action: PayloadAction<BranchType[]>) => {
      const branches = action.payload;
      state.branches = branches;
      state.branchesLoaded = true;

      if (branches.length === 1) {
        state.selectedBranch = branches[0];
        localStorage.setItem("selectedBranch", String(branches[0].id));
        state.isBranchModalOpen = false;
      } else if (branches.length > 1) {
        const savedId = localStorage.getItem("selectedBranch");
        const matched = savedId
          ? branches.find((b) => String(b.id) === savedId) ?? null
          : null;

        if (matched) {
          state.selectedBranch = matched;
          state.isBranchModalOpen = false;
        } else {
          state.isBranchModalOpen = true;
        }
      }
    },
  },
});

export const { updateIsImgModalOpen, setSelectedBranch, setBranchesFromResponse } = settingsSlice.actions;

export const getIsImgModalOpen = (state: RootState) =>
  state.settings.isImgModalOpen;
export const getBranches = (state: RootState) => state.settings.branches;
export const getSelectedBranch = (state: RootState) =>
  state.settings.selectedBranch;
export const getIsBranchModalOpen = (state: RootState) =>
  state.settings.isBranchModalOpen;
export const getBranchesLoaded = (state: RootState) =>
  state.settings.branchesLoaded;

export default settingsSlice.reducer;
